import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { translate } from 'react-polyglot'

import { Shortcut, Button, Icon } from 'components'

import './shortcutModal.scss'

class ShortcutModal extends PureComponent {
	componentDidMount() {
		window.addEventListener('keydown', this.onKeyDown, true)
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown, true)
	}

	onKeyDown = e => {
		if (e.keyCode === 27) {
			this.onClose()
		}
	}

	onClose = () => {
		const { onClose } = this.props

		if (onClose) {
			onClose()
		}
	}

	render() {
		const { visible, t } = this.props

		if (visible === false) {
			return null
		}

		return ReactDOM.createPortal(
			<div className="c-shortcut-modal">
				<div className="c-shortcut-modal__header">
					<div className="c-shortcut-modal__title">
						{t('shortcuts')}
					</div>
					<div className="c-shortcut-modal__close">
						<Button
							icon={<Icon name="close" />}
							onClick={this.onClose}
						/>
					</div>
				</div>
				<div className="c-shortcut-modal__groups">
					<div className="c-shortcut-modal__group">
						<h3>{t('general')}</h3>
						<Shortcut label commandKey="quickCommand" />
						{/* <Shortcut label commandKey="mention" /> Feature gibt es noch nicht */}
						<Shortcut label commandKey="emoji" />
						{/* <Shortcut label commandKey="uploadImage" /> */}
						{/* <Shortcut label commandKey="uploadFile" /> */}
						<Shortcut label commandKey="undo" />
						<Shortcut label commandKey="redo" />
						<Shortcut label commandKey="indent" />
						<Shortcut label commandKey="unindent" />
						{/* <Shortcut label commandKey="moveUp" /> Feature gibt es noch nicht */}
						{/* <Shortcut label commandKey="moveDown" /> Feature gibt es noch nicht */}
						{/* <Shortcut label commandKey="setHr" /> Markdown */}
					</div>
					<div className="c-shortcut-modal__group">
						<h3>{t('formatting')}</h3>
						<Shortcut label commandKey="setBold" />
						<Shortcut label commandKey="setItalic" />
						{/* <Shortcut label commandKey="setLink" /> Shortcut noch nicht umgesetzt */}
						<Shortcut label commandKey="setCode" />
						{/* <Shortcut label commandKey="setHighlight" /> */}
						{/* <Shortcut label commandKey="setStrikedThrough" /> */}
					</div>
					<div className="c-shortcut-modal__group">
						<h3>{t('block_formatting')}</h3>
						<Shortcut label commandKey="setParagraph" />
						{/* <Shortcut label commandKey="setH2" /> Shortcut noch nicht umgesetzt */}
						{/* <Shortcut label commandKey="setH3" /> Shortcut noch nicht umgesetzt */}
						{/* <Shortcut label commandKey="setCodeBlock" /> Shortcut noch nicht umgesetzt */}
						{/* <Shortcut label commandKey="setUnorderedList" /> Shortcut noch nicht umgesetzt */}
						{/* <Shortcut label commandKey="setOrderedList" /> Shortcut noch nicht umgesetzt */}
						{/* <Shortcut label commandKey="setCheckList" /> Feature gibt es noch nicht */}
						{/* <Shortcut label commandKey="setHint" /> Shortcut noch nicht umgesetzt */}
						{/* <Shortcut label commandKey="setBlockquote" /> Shortcut noch nicht umgesetzt */}
					</div>
					{/* <div className="c-shortcut-modal__group">
						<h3>{t('application')}</h3>
						<Shortcut label commandKey="createEntry" />
						<Shortcut label commandKey="search" />
						<Shortcut label commandKey="toggleSidebar" />
						<Shortcut label commandKey="openShortcutModal" />
					</div> */}
				</div>
			</div>,
			document.getElementById('root')
		)
	}
}

ShortcutModal.propTypes = {
	visible: PropTypes.bool,
	onClose: PropTypes.func,
}

ShortcutModal.defaultProps = {
	visible: false,
	onClose: null,
}

export default translate()(ShortcutModal)
